export default __webpack_public_path__ + "static/media/acvt-logo.b5068ff5.jpg";